import React from "react"

/**
 * True when the current page is being rendered as an overlay on top of the
 * page the visitor came from (see `src/components/ModalRoute.js`), rather than
 * as a page of its own.
 *
 * The blog-post template reads this to swap its full-page chrome (site header,
 * footer, floating TOC, prev/next arrows) for the case-study sheet.
 */
const ModalRouteContext = React.createContext(false)

export default ModalRouteContext
